// extracted by mini-css-extract-plugin
export default {"vector":"VectorIcon_vector__HnVV1"};